export default "__VITE_ASSET__BlGUi9oX__"